import React from "react";
import ReadSectionCard from "./Components/ReadSectionCard";

const SuspensionSectionByRead = props => {
	const { unsubscribeReasonText, unsubscribeNote } = props;

	const items = [
		{
			key: "unsubscribeReasonText",
			label: "退訂原因",
			xs: 6,
			value: unsubscribeReasonText,
		},
		{
			key: "unsubscribeNote",
			label: "退訂原因補充說明",
			xs: 12,
			value: unsubscribeNote,
		},
	];

	return <ReadSectionCard title="退訂" outlined borderColor="#f44336" headerBg="#e57373" gridSpacing={3} hideEmpty={false} items={items} />;
};

export default SuspensionSectionByRead;
